import axiosInstance from "@/api/config";
import AgenticAI from "@/components/agenticAI";
import { AGENTIC_AI_TOPICS } from "@/components/agenticAI/constants";
import { useAppFeatures } from "@/hooks/useAppFeatures";

import { LokasiAIProvider } from "@lokasi-ai-web-sdk/app";

const AgenticAIPage = () => {
  const { isFeedbackCtaEnabled } = useAppFeatures();

  return (
    <LokasiAIProvider
      httpClient={axiosInstance}
      topics={AGENTIC_AI_TOPICS}
      featureFlags={{ isFeedbackCtaEnabled }}
    >
      <AgenticAI />
    </LokasiAIProvider>
  );
};

export default AgenticAIPage;
